const PMProjects = () => import('@/pages/ProjectManagement/PMProjects.vue');
const PMProject = () => import('@/pages/ProjectManagement/PMProject.vue');

export default [
    {
        path: 'projects',
        name: 'projectManagement.projects',
        component: PMProjects,
        meta: { showSidebar: true },
    },
    {
        path: 'project/:id',
        name: 'projectManagement.project',
        component: PMProject,
        props: true,
        meta: { showSidebar: false },
    },
];
